// src/directives/swipeBack.js

export default {
  mounted(el, binding) {
    let startX = 0;
    let endX = 0;
    const threshold = 50; // Distância mínima para ser considerado um swipe (em pixels)
    const maxTime = 400;  // Tempo máximo para o swipe (em milissegundos)
    const activationZonePercentage = 0.20; // NOVO: 20% da largura da tela para ativar
    let startTime = 0;
    let isSwiping = false; // Flag para evitar acionamentos múltiplos ou conflitos

    function touchStart(e) {
      if (e.touches.length === 1) {
        const touchX = e.touches[0].clientX;
        const screenWidth = window.innerWidth; // Largura da tela do dispositivo

        // SÓ ATIVA SE O TOQUE INICIAL FOR DENTRO DA ZONA DE ATIVAÇÃO
        if (touchX <= screenWidth * activationZonePercentage) {
          startX = touchX;
          startTime = Date.now();
          isSwiping = false; // Resetar flag
        } else {
          // Se o toque inicial não estiver na zona, resetar tudo para ignorar o possível swipe
          startX = 0;
          startTime = 0;
          isSwiping = false;
        }
      }
    }

    function touchMove(e) {
      // Só continua se um touchstart válido na zona de ativação já ocorreu
      if (startX !== 0 && e.touches.length === 1) {
        endX = e.touches[0].clientX;
        const currentDistance = endX - startX;

        // Se já moveu o suficiente para iniciar um "potencial" swipe e na direção certa
        if (currentDistance > 10) { // Um pequeno limiar para começar a considerar swipe para evitar rolagem acidental
            isSwiping = true;
            // Opcional: Se quiser evitar a rolagem da página vertical ao arrastar horizontalmente
            // e.preventDefault(); // Descomente e mude passive: true para passive: false no addEventListener de touchmove
        }
      }
    }

    function touchEnd() {
      // Só processa se um swipe foi iniciado na zona de ativação
      if (isSwiping) {
        const distance = endX - startX;
        const duration = Date.now() - startTime;

        // Condições mais flexíveis para o swipe
        if (distance > threshold && duration < maxTime) {
          if (typeof binding.value === 'function') {
            binding.value();
          }
        }
      }
      // Resetar para o próximo swipe, independentemente de ter sido válido ou não
      startX = 0;
      endX = 0;
      startTime = 0;
      isSwiping = false;
    }

    // Usar { passive: true } para otimizar o desempenho do scroll.
    // Mude para { passive: false } no touchmove se você precisar de e.preventDefault()
    el.addEventListener('touchstart', touchStart, { passive: true });
    el.addEventListener('touchmove', touchMove, { passive: true });
    el.addEventListener('touchend', touchEnd, { passive: true });

    el.cleanup = () => {
      el.removeEventListener('touchstart', touchStart);
      el.removeEventListener('touchmove', touchMove);
      el.removeEventListener('touchend', touchEnd);
    };
  },
  unmounted(el) {
    if (el.cleanup) {
      el.cleanup();
    }
  },
};